import React, { useState, useEffect } from "react";
import "../styles/sevices2.css"; // Assuming this is your CSS file for styling
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper components
import "../../node_modules/swiper/swiper-bundle.min.css"; // Import Swiper styles
import left from "../assests/Images/left.png";
import right from "../assests/Images/right.png";
import { useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { API_BASE_URL } from '../config/api';

const ServicesSection = ({ anim }) => {
  const [, setWindowWidth] = useState(window.innerWidth);
  const [onttimeIndex, setOntimeIndex] = useState(0); // For One Time pagination
  const [miscellaneousIndex, setMiscellaneousIndex] = useState(0); // For Miscellaneous pagination
  const [repeatedIndex, setRepeatedIndex] = useState(0); // For Repeated pagination

  const swiperOneRef = useRef(null);
  const swiperrepeatedRef = useRef(null);
  const swiperMiscellaneousRef = useRef(null);

  // Interval and hover state refs for each service type
  const intervalOneRef = useRef(null);
  const intervalRepeatedRef = useRef(null);
  const intervalMiscellaneousRef = useRef(null);

  const isHoveredOneRef = useRef(false);
  const isHoveredRepeatedRef = useRef(false);
  const isHoveredMiscellaneousRef = useRef(false);

  const [oneTimeServices, setOneTimeServices] = useState(
    localStorage.getItem("services")
      ? JSON.parse(localStorage.getItem("services")).filter(
          (service) => service.type === "one-time"
        )
      : []
  );
  const [repeatedServices, setRepeatedServices] = useState(
    localStorage.getItem("services")
      ? JSON.parse(localStorage.getItem("services")).filter(
          (service) => service.type === "renewal"
        )
      : []
  );
  const [miscellaneousServices, setMiscellaneousServices] = useState(
    localStorage.getItem("services")
      ? JSON.parse(localStorage.getItem("services")).filter(
          (service) => service.type === "misc"
        )
      : []
  );

  const scrollLeft = (service) => {
    if (service === "oneTime" && swiperOneRef.current) {
      swiperOneRef.current.swiper.slidePrev();
    } else if (service === "repeated" && swiperrepeatedRef.current) {
      swiperrepeatedRef.current.swiper.slidePrev();
    } else if (service === "miscellaneous" && swiperMiscellaneousRef.current) {
      swiperMiscellaneousRef.current.swiper.slidePrev();
    }
  };

  const scrollRight = (service) => {
    if (service === "oneTime" && swiperOneRef.current) {
      swiperOneRef.current.swiper.slideNext();
    } else if (service === "repeated" && swiperrepeatedRef.current) {
      swiperrepeatedRef.current.swiper.slideNext();
    } else if (service === "miscellaneous" && swiperMiscellaneousRef.current) {
      swiperMiscellaneousRef.current.swiper.slideNext();
    }
  };

  // Auto-slide functions for each service type
  const startAutoSlideOne = () => {
    if (!intervalOneRef.current) {
      intervalOneRef.current = setInterval(() => {
        if (swiperOneRef.current && !isHoveredOneRef.current) {
          swiperOneRef.current.swiper.slideNext();
        }
      }, 3000);
    }
  };

  const startAutoSlideRepeated = () => {
    if (!intervalRepeatedRef.current) {
      intervalRepeatedRef.current = setInterval(() => {
        if (swiperrepeatedRef.current && !isHoveredRepeatedRef.current) {
          swiperrepeatedRef.current.swiper.slidePrev();
        }
      }, 3000);
    }
  };

  const startAutoSlideMiscellaneous = () => {
    if (!intervalMiscellaneousRef.current) {
      intervalMiscellaneousRef.current = setInterval(() => {
        if (
          swiperMiscellaneousRef.current &&
          !isHoveredMiscellaneousRef.current
        ) {
          swiperMiscellaneousRef.current.swiper.slideNext();
        }
      }, 3000);
    }
  };

  const stopAutoSlideOne = () => {
    if (intervalOneRef.current) {
      clearInterval(intervalOneRef.current);
      intervalOneRef.current = null;
    }
  };

  const stopAutoSlideRepeated = () => {
    if (intervalRepeatedRef.current) {
      clearInterval(intervalRepeatedRef.current);
      intervalRepeatedRef.current = null;
    }
  };

  const stopAutoSlideMiscellaneous = () => {
    if (intervalMiscellaneousRef.current) {
      clearInterval(intervalMiscellaneousRef.current);
      intervalMiscellaneousRef.current = null;
    }
  };

  // Hover handlers for each service type
  const handleMouseEnterOne = () => {
    isHoveredOneRef.current = true;
  };

  const handleMouseLeaveOne = () => {
    isHoveredOneRef.current = false;
  };

  const handleMouseEnterRepeated = () => {
    isHoveredRepeatedRef.current = true;
  };

  const handleMouseLeaveRepeated = () => {
    isHoveredRepeatedRef.current = false;
  };

  const handleMouseEnterMiscellaneous = () => {
    isHoveredMiscellaneousRef.current = true;
  };

  const handleMouseLeaveMiscellaneous = () => {
    isHoveredMiscellaneousRef.current = false;
  };

  // Update window width when the window is resized
  useEffect(() => {
    // Start auto-slide for all service types
    startAutoSlideOne();
    startAutoSlideRepeated();
    startAutoSlideMiscellaneous();

    if (anim !== "true") {
      AOS.init({
        duration: 1000, // Optional: you can customize the animation duration or other settings
        once: true, // Optional: ensures animations only trigger once
        startEvent: "DOMContentLoaded", // Optional: triggers AOS on specific event
      });
    }

    const fetchData = async () => {
      const response = await axios.get(`${API_BASE_URL}/api/services/`);

      localStorage.setItem("services", JSON.stringify(response.data));
      setOneTimeServices(
        response.data.filter((service) => service.type === "one-time")
      );
      setRepeatedServices(
        response.data.filter((service) => service.type === "renewal")
      );
      setMiscellaneousServices(
        response.data.filter((service) => service.type === "misc")
      );
    };
    fetchData();

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      // Clean up intervals
      stopAutoSlideOne();
      stopAutoSlideRepeated();
      stopAutoSlideMiscellaneous();
    };
  }, [anim]);

  // Set the breakpoints for Swiper
  const swiperBreakpoints = {
    320: { slidesPerView: 1 },
    768: { slidesPerView: 2 }, // Tablet view
    1024: { slidesPerView: 3 }, // Desktop view
  };

  // Handle Swiper slide change for pagination
  const handleSlideChangeOneTime = (swiper) => setOntimeIndex(swiper.realIndex);
  const handleSlideChangeMiscellaneous = (swiper) =>
    setMiscellaneousIndex(swiper.realIndex);
  const handleSlideChangeRepeated = (swiper) =>
    setRepeatedIndex(swiper.realIndex);

  const getAosData = (anima, delay) => {
    return anim === "true"
      ? null
      : { "data-aos": anima, "data-aos-delay": delay };
  };

  // Calculate the number of circles for pagination
  const totalPagesMiscellaneous =
    miscellaneousServices && Array.isArray(miscellaneousServices)
      ? miscellaneousServices.length
      : 0;
  const totalPagesRepeated =
    repeatedServices && Array.isArray(repeatedServices)
      ? repeatedServices.length
      : 0;
  const totalPagesOneTime =
    oneTimeServices && Array.isArray(oneTimeServices)
      ? oneTimeServices.length
      : 0;

  const serviceType = {
    "one-time": "#d0e8dd",
    renewal: "#cef4fc",
    misc: "#f8d7db",
  };

  return (
    <div id="services" className="container-width services-section">
      <div className="d-flex justify-content-between">
        <h1 {...getAosData("fade-up", 0)} className="section-title fs-2">
          Services
        </h1>
        <button
          onClick={() => {
            window.location.href = "/services";
          }}
          {...getAosData("fade-right", 300)}
          style={{
            fontSize: "15px",
            backgroundColor: "#2CB665",
            color: "white",
            borderRadius: "10px",
            padding: "8px 12px",
            border: "none",
            height: "fit-content",
            textWrap: "nowrap",
          }}
        >
          View All
        </button>
      </div>

      <h2 {...getAosData("fade-up", 0)} className="service-section-title pt-2">
        What we provide
      </h2>
      <p
        {...getAosData("fade-up", 0)}
        className="services-header-txt text-start"
      >
        Our commitment extends to supporting career growth, providing expert
        guidance to help seafarers navigate their maritime careers.
      </p>

      {/* One Time Or Documentation Services Section */}
      <div
        id="services-swiper-container"
        className="services-card-section mt-5 pt-2"
        onMouseEnter={handleMouseEnterOne}
        onMouseLeave={handleMouseLeaveOne}
      >
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="service-section-title" {...getAosData("fade-up", 0)}>
            <span className="greenish">Documentation</span> Services
          </h2>
          <div className="d-flex">
            <button
              {...getAosData("fade-left", 100)}
              onClick={() => scrollLeft("oneTime")}
              className="service-cursor-btn mobile-cursor"
            >
              <img src={left} alt="Previous" />
            </button>
            <button
              {...getAosData("fade-right", 100)}
              onClick={() => scrollRight("oneTime")}
              className="service-cursor-btn mobile-cursor"
            >
              <img src={right} alt="Next" />
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            {...getAosData("fade-left", 200)}
            onClick={() => scrollLeft("oneTime")}
            className="service-cursor-btn desktop-cursor"
          >
            <img src={left} alt="Previous" />
          </button>

          <Swiper
            spaceBetween={20}
            breakpoints={swiperBreakpoints}
            onSlideChange={handleSlideChangeOneTime} // Event listener for slide change
            ref={swiperOneRef}
            {...getAosData("fade-up", 400)}
            className="pb-3"
            loop={true} // Enable continuous loop
          >
            {oneTimeServices &&
              Array.isArray(oneTimeServices) &&
              oneTimeServices.map((service) => (
                <SwiperSlide key={service.id}>
                  <div className="col">
                    <div className="services-card">
                      <div className="service-card-header">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="23"
                          height="23"
                          fill="currentColor"
                          className={`bi ${service.icon}`}
                          viewBox="0 0 16 16"
                        >
                          <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                        </svg>

                        <div className="ms-3">
                          <span
                            class="badge me-2"
                            style={{
                              backgroundColor:
                                service.type === serviceType[service.type]
                                  ? serviceType[service.type]
                                  : serviceType[service.type],
                            }}
                          >
                            {'Documentation'}
                          </span>
                        </div>
                      </div>
                      <h5>{service.name}</h5>
                      <p6
                        style={{
                          fontSize: "14px",
                          color: "#6c757d",
                          marginTop: "0px",
                          paddingTop: "0px",
                        }}
                      >
                        {service.description && service.description.length > 50
                          ? `${service.description.substring(0, 50)}...`
                          : service.description}
                      </p6>
                      <div className="service-card-action-btn">
                        <button
                          onClick={() => {
                            window.location.href = "/services";
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            fill="currentColor"
                            className="bi bi-arrow-right-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l2.147-2.146H4.5A.5.5 0 0 1 4 8z"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
          <button
            {...getAosData("fade-right", 200)}
            onClick={() => scrollRight("oneTime")}
            className="service-cursor-btn desktop-cursor"
          >
            <img src={right} alt="Next" />
          </button>
        </div>
        {/* Custom Pagination for One Time Services */}
        <div {...getAosData("fade-up", 200)} className="slider-nav">
          <div className="circles">
            {Array.from({ length: totalPagesOneTime }).map((_, index) => (
              <span
                key={index}
                className={index === onttimeIndex ? "circle active" : "circle"}
              ></span>
            ))}
          </div>
        </div>
      </div>

      {/* Repeated Services or Documentation Renewal Section */}
      <div
        id="services-swiper-container"
        className="services-card-section mt-3 pt-2"
        onMouseEnter={handleMouseEnterRepeated}
        onMouseLeave={handleMouseLeaveRepeated}
      >
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="service-section-title" {...getAosData("fade-up", 0)}>
            <span className="greenish">Documentation Renewal</span> Services
          </h2>
          <div className="d-flex">
            <button
              {...getAosData("fade-left", 100)}
              onClick={() => scrollLeft("repeated")}
              className="service-cursor-btn mobile-cursor"
            >
              <img src={left} alt="Previous" />
            </button>
            <button
              {...getAosData("fade-right", 100)}
              onClick={() => scrollRight("repeated")}
              className="service-cursor-btn mobile-cursor"
            >
              <img src={right} alt="Next" />
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-4">
          <button
            {...getAosData("fade-left", 100)}
            onClick={() => scrollLeft("repeated")}
            className="service-cursor-btn desktop-cursor"
          >
            <img src={left} alt="Previous" />
          </button>

          <Swiper
            spaceBetween={20}
            breakpoints={swiperBreakpoints}
            onSlideChange={handleSlideChangeRepeated}
            ref={swiperrepeatedRef}
            {...getAosData("fade-up", 400)}
            className="pb-3"
            loop={true} // Enable continuous loop
          >
            {repeatedServices &&
              Array.isArray(repeatedServices) &&
              repeatedServices.map((service) => (
                <SwiperSlide key={service.id}>
                  <div className="col">
                    <div className="services-card">
                      <div className="service-card-header">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="23"
                          height="23"
                          fill="currentColor"
                          className={`bi ${service.icon}`}
                          viewBox="0 0 16 16"
                        >
                          <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                        </svg>

                        <div className="ms-3">
                          <span
                            class="badge me-2"
                            style={{
                              backgroundColor:
                                service.type === serviceType[service.type]
                                  ? serviceType[service.type]
                                  : serviceType[service.type],
                            }}
                          >
                            {'Documentation Renewal'}
                          </span>
                        </div>
                      </div>
                      <h5>{service.name}</h5>
                      <p6 style={{ fontSize: "14px", color: "#6c757d" }}>
                        {service.description && service.description.length > 50
                          ? `${service.description.substring(0, 50)}...`
                          : service.description || "No description available"}
                      </p6>
                      <div className="service-card-action-btn">
                        <button
                          onClick={() => {
                            window.location.href = "/services";
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            fill="currentColor"
                            className="bi bi-arrow-right-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l2.147-2.146H4.5A.5.5 0 0 1 4 8z"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
          <button
            {...getAosData("fade-right", 200)}
            onClick={() => scrollRight("repeated")}
            className="service-cursor-btn desktop-cursor"
          >
            <img src={right} alt="Next" />
          </button>
        </div>
        {/* Custom Pagination for Repeated Services */}
        <div {...getAosData("fade-up", 200)} className="slider-nav">
          <div className="circles">
            {Array.from({ length: totalPagesRepeated }).map((_, index) => (
              <span
                key={index}
                className={index === repeatedIndex ? "circle active" : "circle"}
              ></span>
            ))}
          </div>
        </div>
      </div>

      {/* Miscellaneous Services Section */}
      <div
        id="services-swiper-container"
        className="services-card-section mt-3 pt-2"
        onMouseEnter={handleMouseEnterMiscellaneous}
        onMouseLeave={handleMouseLeaveMiscellaneous}
      >
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="service-section-title" {...getAosData("fade-up", 0)}>
            <span className="greenish">Miscellaneous</span> Services
          </h2>
          <div className="d-flex">
            <button
              {...getAosData("fade-left", 100)}
              onClick={() => scrollLeft("miscellaneous")}
              className="service-cursor-btn mobile-cursor"
            >
              <img src={left} alt="Previous" />
            </button>
            <button
              {...getAosData("fade-right", 100)}
              onClick={() => scrollRight("miscellaneous")}
              className="service-cursor-btn mobile-cursor"
            >
              <img src={right} alt="Next" />
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-4">
          <button
            {...getAosData("fade-left", 100)}
            onClick={() => scrollLeft("miscellaneous")}
            className="service-cursor-btn desktop-cursor"
          >
            <img src={left} alt="Previous" />
          </button>

          <Swiper
            spaceBetween={20}
            breakpoints={swiperBreakpoints}
            onSlideChange={handleSlideChangeMiscellaneous}
            ref={swiperMiscellaneousRef}
            {...getAosData("fade-up", 400)}
            className="pb-3"
            loop={true} // Enable continuous loop
          >
            {miscellaneousServices &&
              Array.isArray(miscellaneousServices) &&
              miscellaneousServices.map((service) => (
                <SwiperSlide key={service.id}>
                  <div className="col">
                    <div className="services-card">
                      <div className="service-card-header">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="23"
                          height="23"
                          fill="currentColor"
                          className={`bi ${service.icon}`}
                          viewBox="0 0 16 16"
                        >
                          <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                        </svg>

                        <div className="ms-3">
                          <span
                            class="badge me-2"
                            style={{
                              backgroundColor:
                                service.type === serviceType[service.type]
                                  ? serviceType[service.type]
                                  : serviceType[service.type],
                            }}
                          >
                            {service.type_verbose}
                          </span>
                        </div>
                      </div>
                      <h5>{service.name}</h5>
                      <p6 style={{ fontSize: "14px", color: "#6c757d" }}>
                        {service.description && service.description.length > 50
                          ? `${service.description.substring(0, 50)}...`
                          : service.description || "No description available"}
                      </p6>
                      <div className="service-card-action-btn">
                        <button
                          onClick={() => {
                            window.location.href = "/services";
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            fill="currentColor"
                            className="bi bi-arrow-right-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l2.147-2.146H4.5A.5.5 0 0 1 4 8z"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
          <button
            {...getAosData("fade-right", 200)}
            onClick={() => {
              scrollRight("miscellaneous");
            }}
            className="service-cursor-btn desktop-cursor"
          >
            <img src={right} alt="Next" />
          </button>
        </div>
        {/* Custom Pagination for Miscellaneous Services */}
        <div {...getAosData("fade-up", 200)} className="slider-nav">
          <div className="circles">
            {Array.from({ length: totalPagesMiscellaneous }).map((_, index) => (
              <span
                key={index}
                className={
                  index === miscellaneousIndex ? "circle active" : "circle"
                }
              ></span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
